exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".delivery-details{display:block}", "", {"version":3,"sources":["C:/a/_work/5/s/src/views/AssetDetailsPage/components/DeliveryDetails/C:/a/_work/5/s/src/views/AssetDetailsPage/components/DeliveryDetails/DeliveryDetails.scss"],"names":[],"mappings":"AAAA,kBACI,aAAc,CACjB","file":"DeliveryDetails.scss","sourcesContent":[".delivery-details {\r\n    display: block;\r\n}\r\n"],"sourceRoot":""}]);

// exports
